const URLS = {
  CREATE_ACCOUNT_BUBBLE: '/auth/view/createaccount?fromReminder=true',
  SIGN_IN_BUBBLE: '/auth/view/signin?fromReminder=true',
};

const EVENTS = {
  AUDIENCE_IDENTIFIED: 'ocm_pd_component_sign-in-bubble.pro-audience-identified',
  BUBBLE_READY: 'ocm_pd_component_sign-in-bubble.ready',
};

const AUDIENCE_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C',
};

const QUERY_PARAMS = {
  CABINET: 'DesignStyleChoiceid'
};

const PATH_NAMES = {
  CABINET: '/cabinet',
};

export {
  URLS,
  EVENTS,
  AUDIENCE_TYPE,
  QUERY_PARAMS,
  PATH_NAMES
};